import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    description: 'User Management title name',
    defaultMessage: 'User Management',
    id: 'MP7naE',
  },
  description: {
    description: 'User Management header description',
    defaultMessage:
      'Manage who has access to ShipStation, what they can do, and which features they can use. Assign roles, customize permissions, and control access to advanced tools to keep your team productive and secure. <link>Learn more about user roles</link>',
    id: 'wCGlVV',
  },
  userCount: {
    description: 'User Management available user count',
    defaultMessage:
      '<b>{activeUserCount}</b> active {activeUserCount, plural, one {user is} other {users are}} being used. Your subscription supports {subscriptionUserCount, plural, one {# user} other {# users}}.',
    id: 'h+iZiv',
  },
  upgradeSubscription: {
    description: 'Info on why no more users can be added',
    defaultMessage:
      '<b>New users cannot be added until another one is deactivated or removed. You can alternatively <a>upgrade your subscription</a></b>',
    id: 'vepLRz',
  },
  unlimited: {
    description: 'The word unlimited. In context with how many users an account could have.',
    defaultMessage: 'unlimited',
    id: 'qOwlOE',
  },
  showInactiveUsers: {
    description: 'Show Inactive Users checkbox label',
    defaultMessage: 'Show Inactive Users',
    id: 'fAuhce',
  },
  addUser: {
    description: 'Add user button text',
    defaultMessage: 'Add a User Account',
    id: 'pcXQEj',
  },
  username: {
    description: 'Username column header',
    defaultMessage: 'Username',
    id: 'r8fLFP',
  },
  name: {
    description: 'Name column header',
    defaultMessage: 'Name',
    id: 'PIZW8F',
  },
  email: {
    description: 'Email column header',
    defaultMessage: 'E-mail',
    id: 'xLubBa',
  },
  lastLogin: {
    description: 'Last Login column header',
    defaultMessage: 'Last Login',
    id: '0d7ZoE',
  },
  status: {
    description: 'Status column header',
    defaultMessage: 'Status',
    id: 'eLQPek',
  },
  active: {
    description: 'Status column - active text',
    defaultMessage: 'Active',
    id: '/6wUl9',
  },
  inactive: {
    description: 'Status column - inactive text',
    defaultMessage: 'Inactive',
    id: '+FmhrO',
  },
  locked: {
    description: 'Status column - locked text',
    defaultMessage: 'Locked',
    id: 'Tob6RZ',
  },
  emailLock: {
    description: 'Status column - email locked text',
    defaultMessage: 'Email Lock',
    id: 'DjDruW',
  },
  edit: {
    description: 'Edit button text',
    defaultMessage: 'Edit',
    id: 'hcDY47',
  },
  analyticsAccess: {
    description: 'Column header for analytics access status in user grid',
    defaultMessage: 'Analytics',
    id: 'SgHP4J',
  },
});
